import { Linkedin, Youtube } from "lucide-react"
import React from "react"
import { Button } from "../ui/Button"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip"

interface SocialLinkProps {
  href: string
  icon: React.ReactNode
  label: string
}

const SocialLink: React.FC<SocialLinkProps> = ({ href, icon, label }) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="rounded-full hover:bg-gray-100 dark:hover:bg-gray-800"
          asChild
        >
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
          >
            {icon}
          </a>
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top">
        <p className="text-sm">{label}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
)

const SocialLinks: React.FC = () => {
  return (
    <div className="flex items-center gap-2">
      <SocialLink
        href="https://www.youtube.com/channel/UClDqqE1vKPe0mkRcX7snJcg"
        icon={<Youtube className="size-5" />}
        label="UIC on YouTube"
      />
      <SocialLink
        href="https://www.linkedin.com/company/uicrail/"
        icon={<Linkedin className="size-5" />}
        label="UIC on LinkedIn"
      />
      {/* <SocialLink
        href="https://www.instagram.com/uicrail/"
        icon={<Instagram className="size-5" />}
        label="UIC on Instagram"
      /> */}
      {/* <SocialLink href="https://x.com/uic" icon={<Twitter className="size-5" />} label="UIC on Twitter" /> */}
      <SocialLink
        href="https://www.pinterest.com/uicrailways/"
        icon={
          <svg
            className="fill-foreground size-5"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M16.292 5C10.536 5 7.48 8.866 7.48 13.077c0 1.955 1.039 4.392 2.707 5.168.253.118.387.064.443-.18.047-.185.273-1.089.373-1.511a.402.402 0 0 0-.095-.386c-.55-.667-.988-1.896-.988-3.041 0-2.942 2.228-5.787 6.021-5.787 3.28 0 5.571 2.23 5.571 5.426 0 3.61-1.82 6.108-4.191 6.108-1.309 0-2.291-1.081-1.978-2.413.378-1.584 1.106-3.298 1.106-4.438 0-1.026-.552-1.883-1.685-1.883-1.341 0-2.415 1.385-2.415 3.241 0 1.182.4 1.978.4 1.978s-1.323 5.593-1.563 6.634c-.413 1.765.051 4.625.094 4.876.021.134.172.18.252.066.129-.175 1.725-2.565 2.174-4.292l.828-3.171c.439.829 1.707 1.531 3.061 1.531 4.021 0 6.923-3.703 6.923-8.299C24.52 8.301 20.92 5 16.292 5z" />
          </svg>
        }
        label="UIC on Pinterest"
      />
    </div>
  )
}

export default SocialLinks
